import styled from 'styled-components';
import spinnerIcon from '../../../assets/images/spinner.svg?react';
import InfoIcons from '../../../assets/images/info-icons.svg?react';
import CloseSvg from '../../../assets/images/close-icon.svg?react';

interface DefaultModalProps {
  $isOpen?: boolean;
  $isLoading?: boolean;
  $flexDirectionContent?: 'row' | 'column';
  $preventBackgroundInteraction?: boolean;
  $isErrorModal?: boolean;
}

export const BackDrop = styled.div<DefaultModalProps>`
  display: ${(props) => (props.$isOpen ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: ${(props) => (props.$preventBackgroundInteraction ? '9999' : '1040')};
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  pointer-events: ${(props) => (props.$isOpen ? 'auto' : 'none')};
`;

export const Modal = styled.div<DefaultModalProps>`
  display: ${(props) => (props.$isOpen ? 'block' : 'none')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 0.625rem 3.125rem rgba(0, 0, 0, 0.5);
  z-index: ${(props) => (props.$preventBackgroundInteraction ? '10000' : '1050')};
  max-height: 50rem;
  min-width: 21.875rem;
  box-sizing: border-box;
  overflow-y: auto;
  @media only screen and (max-width: ${(props) => props.theme.breakpoints.sm}) {
    left: 0;
    right: 0;
    width: auto;
    max-width: none;
    min-width: 0;
    margin: 0 0.625rem;
    max-height: calc(100vh - 2rem);
    transform: translateY(-50%);
    overflow-x: hidden;
  }
`;

export const ModalTitle = styled.div<DefaultModalProps>`
  font-weight: 600 !important;
  margin-bottom: 0;
  font-size: ${(props) => (props.$isLoading ? '0.8rem' : '1.563rem')} !important;
  display: flex;
  line-height: ${(props) => (props.$isErrorModal ? '38px' : 'normal')} !important;
  font-style: normal;
  justify-content: center;
  align-items: center;
  font-family: Poppins !important;
  text-align: center !important;
  color: ${(props) => {
    if (props.$isLoading) return props.theme.colors.textDarkGrey;
    if (props.$isErrorModal) return props.theme.colors.textPrimaryLd;
    return props.theme.colors.textPrimaryLd;
  }} !important;
  @media only screen and (max-width: ${(props) => props.theme.breakpoints.sm}) {
    font-size: 1.25rem !important;
    font-weight: 500 !important;
    line-height: ${(props) => (props.$isErrorModal ? 'normal' : 'normal')};
  }
`;

export const ModalBody = styled.div`
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Poppins, sans-serif;
  flex-direction: column;
  gap: 1.563rem;
  padding: 3.125rem;
  position: relative;
  @media only screen and (max-width: ${(props) => props.theme.breakpoints.sm}) {
    padding: 3.125rem 1.25rem;
  }
`;

export const CloseButton = styled.button`
  display: none;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.textDarkGrey};
  cursor: pointer;
  padding: 0.25rem;
  z-index: 1;

  @media only screen and (max-width: ${(props) => props.theme.breakpoints.sm}) {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
`;

export const CloseIcon = styled(CloseSvg)`
  width: 0.875rem;
  height: 0.875rem;
`;

export const ModalContent = styled.div<DefaultModalProps>`
  font-weight: 400;
  margin-bottom: 0;
  font-size: ${(props) => (props.$isLoading ? '0.8rem' : '1.25rem')};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Poppins, sans-serif;
  line-height: normal;
  font-style: normal;
  white-space: normal;
  text-align: justify;
  color: ${({ theme }) => theme.colors.textDarkGrey};
  p div {
    flex-direction: ${(props) => props.$flexDirectionContent};
  }
  @media only screen and (max-width: ${(props) => props.theme.breakpoints.sm}) {
    font-size: 0.75rem;
    ul {
      padding-left: 1.25rem;
      a {
        color: ${({ theme }) => theme.colors.textDarkGrey};
      }
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  max-height: 20vh;
  width: 100%;
`;

export const Spinner = styled(spinnerIcon)`
  width: 3.438rem;
  height: 3.438rem;
  margin-bottom: 3rem;
`;

export const InfoIcon = styled(InfoIcons)`
  width: 1.5rem;
  height: 1.714rem;
  margin-left: 1rem;
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.colors.primary};
  }
  @media only screen and (max-width: ${(props) => props.theme.breakpoints.sm}) {
    width: 3.25rem;
  }
`;
